<template>
  <div class="col-sm-12">
    <br />
    <div class="col-sm-2">
      <div class="filters">
        <h5><i class="fa fa-cog" /> Filters and Preferences</h5>
        <hr />
        <div class="radio">
          <label class="small">
            <input
              type="radio"
              value="true"
              v-model="query.Incremental"
            />Incremental</label
          >
        </div>
        <div class="radio">
          <label class="small">
            <input
              type="radio"
              value="false"
              v-model="query.Incremental"
            />Non-Incremental</label
          >
        </div>
        <div class="form-to-date">
          <div class="form-group">
            <div class="input-group date" id="chartsFromDate">
              <input
                v-model="query.FromDate"
                class="form-control input-text"
                readonly="true"
                placeholder="From Date"
              />
              <span class="input-group-addon">
                <span class="fa fa-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-to-date">
          <div class="form-group">
            <div class="input-group date" id="chartsToDate">
              <input
                v-model="query.ToDate"
                class="form-control input-text"
                readonly="true"
                placeholder="To Date"
              />
              <span class="input-group-addon">
                <span class="fa fa-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-location">
          <div class="form-group">
            <div class="form-group">
              <select
                required
                v-if="countriesListComp"
                name="serviceSelect"
                class="form-control"
                v-model="query.CountryId"
              >
                <option value="null" disabled selected hidden>
                  Filter specific country
                </option>
                <option value="0">All Countries</option>
                <option
                  v-for="country in countriesListComp"
                  v-bind:value="country.CountryId"
                >
                  {{ country.CountryName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-9">
      <h2 class="text-center">Pet Owners vs Pet Sitters</h2>
      <line-chart
        :chart-data="usersSittersData"
        :options="chartOptions"
        :width="1200"
      ></line-chart>
      <br />
      <hr />
      <br />
      <h2 class="text-center">Bookings Chart</h2>
      <line-chart
        :chart-data="bookingsChartData"
        :options="chartOptions"
        :width="1200"
      ></line-chart>
    </div>
  </div>
</template>

<script>
import auth from "../../auth/index";
import store from "../../data/store";
import commonApi from "../../services/commonApi";
import customerApi from "../../services/customerApi";
import LineChart from "../Admin/Components/LineChart.js";

export default {
  data() {
    return {
      chartOptions: {
        responsive: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                unitStepSize: 1,
                unit: "day",
                displayFormats: {
                  day: "MMM D",
                },
              },
              ticks: {
                source: "auto",
              },
            },
          ],
        },
        legend: {
          display: true,
        },
      },
      error: "",
      usersSittersData: null,
      bookingsChartData: null,
      alert: "",
      emailConfirmed: true,
      query: {
        Incremental: false,
        CountryId: 0,
        FromDate: null,
        ToDate: null,
      },
      title: "Dupaws admin control",
      pending: true,
    };
  },
  components: {
    LineChart,
  },
  updated: function () {
    $('[data-toggle="popover"]').popover();

    // $zopim(function () {
    //   $zopim.livechat.hideAll();

    // });

    if (this.userRoleComp != "Admin") {
      this.$router.push({
        path: "/404",
      });
      return;
    }
  },
  mounted: function () {
    var self = this;
    this.getBookingsChartData();
    this.getUsersSittersChartData();
    // $zopim(function () {
    //   $zopim.livechat.hideAll();

    // });

    self.$nextTick(function () {
      var self = this;
      $("#chartsFromDate")
        .datepicker({
          autoclose: true,
          format: "yyyy-mm-dd",
          todayHighlight: true,
          beforeShowDay: function (date) {},
        })
        .on("changeDate", function (selected) {
          //When changing date..
          self.query.FromDate = moment(selected.date).format("YYYY-MM-DD");
        });
      $("#chartsToDate")
        .datepicker({
          autoclose: true,
          format: "yyyy-mm-dd",
          todayHighlight: true,
          beforeShowDay: function (date) {},
        })
        .on("changeDate", function (selected) {
          //When changing date..
          self.query.ToDate = moment(selected.date).format("YYYY-MM-DD");
        });
    }); // end of nextTick!
  },
  methods: {
    getBookingsChartData: function () {
      var self = this;
      $.ajax("https://www.dupaws.com/services/api/admin/getBookingsChart/", {
        type: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        data: JSON.stringify(self.query),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        crossDomain: true,
        success: function (data) {
          self.loading = false;
          self.searching = false;
          self.bookingsChartData = data;
        },
        error: function (error) {
          self.loading = false;
          self.searching = false;
        },
      });
    },
    getUsersSittersChartData: function () {
      var self = this;
      $.ajax(
        "https://www.dupaws.com/services/api/admin/getUsersSittersChart/",
        {
          type: "POST",
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              "Authorization",
              "bearer " + localStorage.getItem("access_token")
            );
          },
          data: JSON.stringify(self.query),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          crossDomain: true,
          success: function (data) {
            self.loading = false;
            self.searching = false;
            self.usersSittersData = data;
          },
          error: function (error) {
            self.loading = false;
            self.searching = false;
          },
        }
      );
    },
  },
  watch: {
    "query.FromDate": function () {
      this.getUsersSittersChartData();
      this.getBookingsChartData();
    },
    "query.ToDate": function () {
      this.getUsersSittersChartData();
      this.getBookingsChartData();
    },
    "query.CountryId": function () {
      this.getUsersSittersChartData();
      this.getBookingsChartData();
    },
    "query.Incremental": function () {
      this.getUsersSittersChartData();
      this.getBookingsChartData();
    },
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title,
      };
    },
  },
  computed: {
    countriesListComp: function () {
      return store.getters.CountriesList;
    },
    errorMsg: function () {
      return this.error;
    },
    alertMsg: function () {
      return this.alert;
    },
    userRoleComp: function () {
      return store.getters.userRole;
    },
  },
};
</script>
<style scoped>
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #ffffff;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// ChartsDashboard.vue?e71d5224